import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";
import FloatingWhatsapp from "./FloatingWhatsapp";

const ScrollResetOnRoute = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  return null;
};

export const Layout = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <ScrollResetOnRoute />
      <Navbar />
      <main className={isHome ? "flex-1" : "flex-1 pt-16 lg:pt-20"}>
        <Outlet />
      </main>
      <Footer />
      <FloatingWhatsapp />
      <ScrollToTop />
    </div>
  );
};

export default Layout;
